import axios from 'axios'
const baseUrl = `${process.env.REACT_APP_BACKEND_HOST}/admin`

// 내 인사관리

// 대시보드 - 연차
export const getMyLeaveSummary = async (userId) => {
  try {
    const res = await axios.get(`${baseUrl}/salus-vacation/me/${userId}`)
    return res
  } catch (error) {
    console.error('error::', error)
    throw error
  }
}

// 대시보드 정보
export const getMyEmployeeInfo = async (userId) => {
  try {
    const res = await axios.get(`${baseUrl}/salus-hr/employees/me`, {
      params: { userId },
    })
    return res
  } catch (error) {
    console.error('error::', error)
    throw error
  }
}

// 직원 단건 조회
export const getEmployee = async (employeeId) => {
  try {
    const res = await axios.get(`${baseUrl}/salus-hr/employees/${employeeId}`)
    return res
  } catch (error) {
    console.error('error::', error)
    throw error
  }
}

// 관리자 전용 직원 등록
export const createEmployee = async (request, { userId }) => {
  try {
    const res = await axios.post(`${baseUrl}/salus-hr/employees/new`, request, {
      params: { userId },
    })
    return res
  } catch (error) {
    console.error('error::', error)
    throw error
  }
}

// 직원 등록 템플릿 조회
export const getEmployeeCreationTemplate = async () => {
  try {
    const res = await axios.get(
      `${baseUrl}/salus-hr/employees/creation-template`,
    )
    return res
  } catch (error) {
    console.error('error::', error)
    throw error
  }
}

// 전체 직원 목록 조회
export const getAllEmployees = async () => {
  try {
    const res = await axios.get(`${baseUrl}/salus-hr/employees`)
    return res
  } catch (error) {
    console.error('error::', error)
    throw error
  }
}

// 재직 중인 직원 목록 조회
export const getActiveEmployees = async () => {
  try {
    const res = await axios.get(`${baseUrl}/salus-hr/employees/active`)
    return res
  } catch (error) {
    console.error('error::', error)
    throw error
  }
}

// 직원 정보 수정
export const updateEmployee = async (employeeId, request, { userId }) => {
  try {
    const res = await axios.put(
      `${baseUrl}/salus-hr/employees/${employeeId}/with-user`,
      request,
      {
        params: { userId },
      },
    )
    return res
  } catch (error) {
    console.error('error::', error)
    throw error
  }
}

// 근무 형태 변경
export const changeEmployeeWorkType = async (
  employeeId,
  workType,
  { userId },
) => {
  try {
    const res = await axios.put(
      `${baseUrl}/salus-hr/employees/${employeeId}/work-type`,
      null,
      {
        params: {
          workType,
          userId,
        },
      },
    )
    return res
  } catch (error) {
    console.error('error::', error)
    throw error
  }
}

// 휴직 처리
export const goOnLeave = async (employeeId, { userId }) => {
  try {
    const res = await axios.put(
      `${baseUrl}/salus-hr/employees/${employeeId}/leave`,
      null,
      {
        params: { userId },
      },
    )
    return res
  } catch (error) {
    console.error('error::', error)
    throw error
  }
}

// 복직 처리
export const returnFromLeave = async (employeeId, { userId }) => {
  try {
    const res = await axios.put(
      `${baseUrl}/salus-hr/employees/${employeeId}/return`,
      null,
      {
        params: { userId },
      },
    )
    return res
  } catch (error) {
    console.error('error::', error)
    throw error
  }
}

// 퇴사 처리
export const resignEmployee = async (
  employeeId,
  resignationDate,
  { userId },
) => {
  try {
    const res = await axios.put(
      `${baseUrl}/salus-hr/employees/${employeeId}/resign`,
      null,
      {
        params: {
          resignationDate,
          userId,
        },
      },
    )
    return res
  } catch (error) {
    console.error('error::', error)
    throw error
  }
}

// 직원 삭제
export const deleteEmployee = async (employeeId, { userId }) => {
  try {
    const res = await axios.delete(
      `${baseUrl}/salus-hr/employees/${employeeId}`,
      {
        params: { userId },
      },
    )
    return res
  } catch (error) {
    console.error('error::', error)
    throw error
  }
}

// 직원 상세 프로필 조회
export const getEmployeeProfile = async (employeeId, { userId }) => {
  try {
    const res = await axios.get(
      `${baseUrl}/salus-hr/employees/${employeeId}/profile`,
      {
        params: { userId },
      },
    )
    return res
  } catch (error) {
    console.error('error::', error)
    throw error
  }
}

// 직원 인사 정보 종합 수정
export const updateEmployeeInfo = async (employeeId, request, { userId }) => {
  try {
    const res = await axios.put(
      `${baseUrl}/salus-hr/employees/${employeeId}/info`,
      request,
      {
        params: { userId },
      },
    )
    return res
  } catch (error) {
    console.error('error::', error)
    throw error
  }
}

// 조직도 조회
export const getOrgChart = async (userId) => {
  try {
    const res = await axios.get(`${baseUrl}/salus-hr/employees/org-chart`, {
      params: {
        userId,
      },
    })
    return res
  } catch (error) {
    console.error('error::', error)
    throw error
  }
}

// 직원 인사 정보 조회
export const getEmployeeInfo = async (employeeId, { userId }) => {
  try {
    const res = await axios.get(
      `${baseUrl}/salus-hr/employees/${employeeId}/profile`,
      {
        params: { userId },
      },
    )
    return res
  } catch (error) {
    console.error('error::', error)
    throw error
  }
}

// 재직증명서 발급 요청
export const requestCertificate = async (employeeId, purposeType, userId) => {
  try {
    const res = await axios.post(`${baseUrl}/salus-hr/certificates`, null, {
      params: {
        employeeId,
        purposeType,
        userId,
      },
    })
    return res
  } catch (error) {
    console.error('error::', error)
    throw error
  }
}

// 재직증명서 단건 조회 (ID로 조회 → PDF 데이터용)
export const getCertificate = async (certificateId) => {
  try {
    const res = await axios.get(
      `${baseUrl}/salus-hr/certificates/${certificateId}`,
    )
    return res
  } catch (error) {
    console.error('error::', error)
    throw error
  }
}

// 연봉 계약서 서명 요청
export const requestSalaryContract = async (request, { userId }) => {
  try {
    const res = await axios.post(`${baseUrl}/hr/salary-contracts`, request, {
      params: { userId },
    })
    return res
  } catch (error) {
    console.error('error::', error)
    throw error
  }
}

// 근로 계약서 서명 요청
export const requestEmploymentContract = async (params, { userId }) => {
  try {
    const res = await axios.post(`${baseUrl}/hr/contracts`, params, {
      params: { userId },
    })
    return res
  } catch (error) {
    console.error('error::', error)
    throw error
  }
}

// 계약서 단건 조회 (서명용 - userId 필요)
export const getContract = async (contractId, { userId }) => {
  try {
    const res = await axios.get(`${baseUrl}/hr/contracts/${contractId}`, {
      params: { userId },
    })
    return res
  } catch (error) {
    console.error('error::', error)
    throw error
  }
}

// 계약서 단건 조회 (문서 보기용 - userId 불필요)
export const getContractForView = async (contractId) => {
  try {
    const res = await axios.get(`${baseUrl}/hr/contracts/${contractId}`)
    return res
  } catch (error) {
    console.error('error::', error)
    throw error
  }
}

// 계약서 문서 보기 (완료 상태일 때 사용 - userId 필요, IP/User-Agent 헤더 포함)
export const viewContract = async (contractId, { userId }) => {
  try {
    const res = await axios.get(`${baseUrl}/hr/contracts/${contractId}/view`, {
      params: { userId },
    })
    return res
  } catch (error) {
    console.error('error::', error)
    throw error
  }
}

// 계약서 최종 서명 처리 (서명된 PDF S3 key 전달)
export const signContract = async (contractId, pdfKey, { userId }) => {
  try {
    const res = await axios.post(`${baseUrl}/hr/contracts/${contractId}/sign`, {
      pdfUrl: pdfKey,
      userId,
    })
    return res
  } catch (error) {
    console.error('error::', error)
    throw error
  }
}
